import { render, staticRenderFns } from "./FullImageView.vue?vue&type=template&id=0df969d2"
import script from "./FullImageView.ts?vue&type=script&lang=ts&external"
export * from "./FullImageView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports